module.exports = "../study/imgs/maps/Kanagawa/S8/Climate/Precipitation/Kanagawa_Precipitation_HadGEM2_RCP45_End.png";